import React, { useEffect, useRef } from "react"
import { Alert } from "@puregym/ui"
import { useAssertiveMessage } from "src/providers/announcerProvider"
import { useTranslation } from "src/i18next"
import {
  useErrorMessage,
  useSetErrorMessage,
} from "src/providers/errorProvider"
import { Spacer } from "src/components/spacer"

export const ErrorAlert: React.FC<{
  mb?: number
}> = ({ mb }) => {
  const { errorMessage } = useErrorMessage()

  const { setErrorMessage } = useSetErrorMessage()

  const alertRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (errorMessage && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }, [errorMessage])

  const { t } = useTranslation("common")

  useAssertiveMessage(errorMessage)

  return errorMessage == null ? null : (
    <Spacer fullWidth={true} mb={mb ?? 1}>
      <Alert
        closeButtonText={t("labels.shared.core.closeMenuButton")}
        onClose={() => setErrorMessage(undefined)}
        variant={"error"}
        style={{ width: "100%" }}
        ref={alertRef}
      >
        {errorMessage}
      </Alert>
    </Spacer>
  )
}
